import type { Layer } from '@geosoft/viewer-sdk';
import type { PointCloudRegistrationState } from '@/state/useViewerStore';

export type PointCloudRoute = 'plugin-potree' | 'cesium-pnts' | 'unavailable';

export interface PointCloudPerformanceSnapshot {
  pointBudget: number;
  loadedTiles: number;
  failedTiles: number;
}

export function isPointCloudLayer(layer: Layer | null | undefined): boolean {
  if (!layer) return false;
  return layer.kind === 'pointcloud';
}

export function resolvePointCloudRoute(args: {
  layer: Layer | null;
  defenceVariantActive: boolean;
  pluginAllowed: boolean;
}): PointCloudRoute {
  const { layer, defenceVariantActive, pluginAllowed } = args;
  if (!layer) return 'unavailable';
  const hasPotree = Boolean(layer.endpoints.potree);
  const hasPnts = Boolean(layer.endpoints.tileset3d);
  if (hasPotree && pluginAllowed && !defenceVariantActive) return 'plugin-potree';
  if (hasPnts) return 'cesium-pnts';
  return 'unavailable';
}

export function registrationLabel(
  state: PointCloudRegistrationState,
): { icon: 'verified' | 'warning' | 'report'; label: string; variant: 'success' | 'warning' | 'error' } {
  if (state === 'registered') {
    return { icon: 'verified', label: 'Registered', variant: 'success' };
  }
  if (state === 'misaligned') {
    return { icon: 'warning', label: 'Misaligned', variant: 'warning' };
  }
  return { icon: 'report', label: 'Needs review', variant: 'error' };
}
